var exports = {
  "kL": "GuildNotificationSettingsModal.module__container___V2Z0SH",
  "uW": "GuildNotificationSettingsModal.module__section___V2Z0SH",
  "Gf": "GuildNotificationSettingsModal.module__sectionTitle___V2Z0SH",
  "yV": "GuildNotificationSettingsModal.module__sectionDescription___V2Z0SH",
  "nv": "GuildNotificationSettingsModal.module__notificationSection___V2Z0SH",
  "RG": "GuildNotificationSettingsModal.module__suppressSection___V2Z0SH",
  "Sj": "GuildNotificationSettingsModal.module__mobilePushSection___V2Z0SH",
  "dY": "GuildNotificationSettingsModal.module__overridesSection___V2Z0SH",
  "dr": "GuildNotificationSettingsModal.module__overridesHeader___V2Z0SH",
  "bY": "GuildNotificationSettingsModal.module__overridesHeaderCell___V2Z0SH",
  "u1": "GuildNotificationSettingsModal.module__overridesHeaderCellLeft___V2Z0SH",
  "c": "GuildNotificationSettingsModal.module__overridesHeaderCellMute___V2Z0SH",
  "IC": "GuildNotificationSettingsModal.module__overrideItem___V2Z0SH",
  "sr": "GuildNotificationSettingsModal.module__overrideHeader___V2Z0SH",
  "yW": "GuildNotificationSettingsModal.module__channelInfo___V2Z0SH",
  "p": "GuildNotificationSettingsModal.module__channelIcon___V2Z0SH",
  "E8": "GuildNotificationSettingsModal.module__channelDetails___V2Z0SH",
  "HA": "GuildNotificationSettingsModal.module__channelName___V2Z0SH",
  "yb": "GuildNotificationSettingsModal.module__categoryName___V2Z0SH",
  "Z5": "GuildNotificationSettingsModal.module__mobileOverrideOptions___V2Z0SH",
  "Ue": "GuildNotificationSettingsModal.module__desktopNotificationOptions___V2Z0SH",
  "of": "GuildNotificationSettingsModal.module__checkboxCell___V2Z0SH",
  "DT": "GuildNotificationSettingsModal.module__removeButton___V2Z0SH",
  "kI": "GuildNotificationSettingsModal.module__iconTertiary___V2Z0SH",
};

module.exports = exports;
